export const WORDS = [
  'wagga',
  'mates',
  'anzac',
  'nowra',
  'bogan',
  'billy',
  'chook',
  'ciggy',
  'crook',
  'dunny',
  'durry',
  'footy',
  'galah',
  'yakka',
  'heaps',
  'nuddy',
  'servo',
  'smoko',
  'tinny',
  'thong',
  'ocker',
  'bloke',
  'yonks',
  'yobbo',
  'beaut',
  'koala',
  'yabby',
  'cooee',
  'dingo',
  'quoll',
  'bilby',
  'parmy',
  'sanga',
  'perth',
  'dubbo',
  'byron',
  'yamba',
  'uluru',
  'kiama',
  'bundy',
  'waltz',
  'reccy',
  'devil',
  'bonza',
  'chips',
  'cuppa',
  'feral',
  'lager',
  'mozzy',
  'yahoo',
  'prawn',
  'snags',
  'swags',
  'bluey',
  'garbo',
  'jaffa',
  'beach',
  'ocean',
  'drink',
  'snake',
  'hawke',
  'kylie',
  'sport',
  'reefs',
  'ayers',
  'crocs',
  'coast',
  'shark',
  'bream',
  'sandy',
  'manly',
  'mynas',
  'south',
  'under',
  'bruny',
  'opals',
  'mines',
  'waves',
  'yacht',
  'beers',
  'kelly',
  'hogan',
  'range',
  'warne',
  'banjo',
  'snowy',
  'flies',
  'sheep',
  'tides',
  'flood',
  'whale',
  'opera',
  'yarra',
  'jelly',
  'hoist',
  'water',
  'vovos',
  'mango',
  'irwin',
  'ashes',
  'slang',
  'bowen',
  'joeys',
  'chiko',
  'scuba',
  'sauce',
  'farms',
  'kayak',
  'rural',
  'hakea',
  'grill',
  'rugby',
  'tents',
  'cathy',
  'coles',
  'penal',
  'vivid',
  'fires',
  'toads',
  'storm',
  'flora',
  'fauna',
  'lucky',
  'swans',
  'venom',
  'windy',
  'views',
  'sunny',
  'skies',
  'races',
  'trots',
  'tidal',
  'bingo',
  'bondi',
  'bight',
  'coral',
  'river',
  'jetty',
  'fence',
  'solar',
  'wheat',
  'gecko',
  'skink',
  'crabs',
  'barby',
  'hydro',
  'chops',
  'fryup',
  'donga',
  'dunes',
  'plonk',
]
